module.exports = __webpack_public_path__ + "static/media/background_GER.e85436ff.jpg";